import { yupResolver } from '@hookform/resolvers/yup';
import { LNGS_NAMESPACE_LOGICAL_DEVICE } from '@ingenico/util-i18n-config';
import type { TFunction } from 'i18next';
import { useEffect } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { object, string } from 'yup';
import { SoftwareType } from '../../domain/models/selectItems.model';

export const softwareTypeOptions = [SoftwareType.Application, SoftwareType.System];

export interface FileOutputFormularyModalSchema {
  readonly softwareType: SoftwareType;
  readonly softwareNameId: string;
  readonly versionId: string;
  readonly moduleId: string;
}

export enum FileOutputFormularyModalSchemaKeys {
  SoftwareTypeField = 'softwareType',
  SoftwareNameIdField = 'softwareNameId',
  VersionIdField = 'versionId',
  ModuleIdField = 'moduleId',
}

const defaultValuesFormulary: FileOutputFormularyModalSchema = {
  softwareType: SoftwareType.None,
  softwareNameId: '',
  versionId: '',
  moduleId: '',
};

function createSchema(t: TFunction) {
  return object().shape({
    softwareType: string().required(t('common:error.required')).oneOf(softwareTypeOptions),
    softwareNameId: string().required(t('common:error.required')),
    versionId: string().required(t('common:error.required')),
    moduleId: string().required(t('common:error.required')),
  });
}

export interface UseFileOutputFormularyModal {
  readonly isOpen: boolean;
}

export function useFileOutputFormularyModal({
  isOpen,
}: UseFileOutputFormularyModal): UseFormReturn<FileOutputFormularyModalSchema> {
  const { t } = useTranslation(Object.values(LNGS_NAMESPACE_LOGICAL_DEVICE));
  const form = useForm<FileOutputFormularyModalSchema>({
    mode: 'onChange',
    defaultValues: defaultValuesFormulary,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    resolver: yupResolver(createSchema(t)) as any,
  });

  useEffect(() => {
    if (!isOpen) {
      form.reset(defaultValuesFormulary);
    }
  }, [form, isOpen]);

  return form;
}
